/**
 * American Hex — Scroll Reveal
 * Watches elements and fades/slides them into view as they enter the viewport.
 * Uses CSS `translate` property (not `transform`) so it doesn't conflict
 * with hover scale/lift effects on cards.
 */
window.ScrollReveal = (function () {

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.07,
    rootMargin: '0px 0px -50px 0px'
  });

  function observe(el) {
    el.classList.add('scroll-reveal');
    io.observe(el);
  }

  function init() {
    // Section headers — anchor each section, no stagger needed
    document.querySelectorAll('.section-header').forEach(observe);

    // Product cards — stagger handled by CSS nth-child delays
    document.querySelectorAll('.product-card').forEach(observe);

    // Split feature panels
    document.querySelectorAll(
      '.split-feature__content, .split-feature__image'
    ).forEach(observe);

    // Brand strip ticker
    document.querySelectorAll('.brand-strip').forEach(observe);
  }

  // Called by video-feed.js after dynamic cards are injected into the DOM
  function initVideoCards() {
    var grid = document.getElementById('video-feed-grid');
    if (!grid) return;
    Array.from(grid.querySelectorAll('.video-card')).forEach(observe);
  }

  document.addEventListener('DOMContentLoaded', init);

  return { observe: observe, initVideoCards: initVideoCards };

})();
